/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const DIRECTOR_CAN_ABILITY = [
  ['read', 'MyProfile'],
  ['read', 'NotFound'],
  ['read', 'OrganizationProfile'],
  ['read', 'Application'],
  ['read', 'DraftAppList'],
  ['read', 'ApplicationStatus'],
  ['read', 'SubmittedAppList'],
  ['read', 'ApplicationDetail'],
  ['read', 'RejectedAppList'],
  ['read', 'EmployeeList'],
  ['read', 'Payment'],
  ['read', 'PaymentSuccess'],
  ['read', 'OrgAdminList'],
  ['read', 'AllUserList'],
  ['read', 'UserProfile'],
  ['read', 'PaymentFailure'],
  ['read', 'ApprovedApplication'],
  ['read', 'MissingInfo'],
  ['read', 'PendingPayment'],
  ['read', 'GenericReport'],
  ['read', 'OrganizationAdmin'],
  ['read', 'AllUserList'],
  ['read', 'UserProfile'],
  ['read', 'InviteAccepted'],
  ['read', 'InviteRejected'],
  ['read', 'InviteStatus'],
  ['read', 'InviteExpired'],
  ['read', 'PaymentHistory'],
];

export const DIRECTOR_CANNOT_ABILITY = [['read', 'MasterAdminInvite']];
